import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/cn'
import type { HTMLAttributes } from 'react'

/**
 * Semantic pill — colour = state. Never used decoratively. Tones mirror the
 * `--ok / --warn / --crit / --mute` tokens shared with legacy Pulse so an
 * operator's colour-to-status recall keeps working after the rewrite.
 */
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11.5px] font-medium leading-none whitespace-nowrap',
  {
    variants: {
      tone: {
        neutral:
          'border-transparent bg-[color:var(--card)] text-[color:var(--muted-foreground)] shadow-[var(--shadow-raised)]',
        info: 'border-[color:var(--secondary)] bg-[color:var(--secondary)] text-[color:var(--secondary-foreground)]',
        ok: 'border-transparent bg-[color:var(--ok-soft)] text-[color:var(--ok)]',
        warn: 'border-transparent bg-[color:var(--warn-soft)] text-[color:var(--warn)]',
        crit: 'border-transparent bg-[color:var(--crit-soft)] text-[color:var(--crit)]',
        mute: 'border-transparent bg-[color:var(--mute-soft)] text-[color:var(--muted-foreground)]',
      },
    },
    defaultVariants: {
      tone: 'neutral',
    },
  },
)

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />
}
